<template>
  <div class="flex justify-center items-center h-screen" id="mainWrapper">
    <div class="max-w-xl w-full">
      <div class="bg-white shadow sm:rounded-lg">
        <slot />
      </div>
    </div>
  </div>
</template>
